import React from 'react';
import { ImageModel, LinkModel } from '../../models/globals';

interface AnnouncementBannerProps {
    cengageLogo: ImageModel;
    cengageGroupLink: LinkModel;
}

const AnnouncementBanner: React.FC<AnnouncementBannerProps> = ({ cengageLogo, cengageGroupLink }) => {
    return (
        <div className="announcement-banner">
            <img alt={cengageLogo.altText} src="/assets/image/cengage-header-logo.svg" className="banner-logo" />
            <div className="content">
                <span className="content-bold">NEW!</span>{' '}
                <span>The Cengage brand now represents global businesses supporting learners from K-12 to Career.</span>{' '}
                <a href={cengageGroupLink.url} className="learn-more">
                    Learn more
                </a>
            </div>
        </div>
    );
};

export default AnnouncementBanner;
